/**
 * Builds the router target for a donor: a CRM contact (Individual) or organisation
 * (Organization). Returns null when the CRM reference isn't available, so the donor
 * name renders as plain text instead of a link that 404s.
 *
 * Never links to `donorId` — that is OPDON's own donor key, not a valid `/contacts/:id`
 * nor `/organisations/:id`.
 */
export function buildDonorRoute(donor) {
    if (donor.donorType === "Organization" && donor.organizationId) {
        return { name: "Organisation", params: { id: donor.organizationId } };
    }
    if (donor.contactId) {
        return { name: "ContactDetail", params: { id: donor.contactId } };
    }
    return null;
}
/**
 * Router target for an organisation record (`/organisations/:id`). Null when no id, so the
 * name renders as plain text. Used by the donation/subscription Summary's "Organisation" row.
 */
export function buildOrganisationRoute(organizationId) {
    return organizationId ? { name: "Organisation", params: { id: organizationId } } : null;
}
/**
 * Router target for a CRM contact record (`/contacts/:id`). Null when no id. Used by the
 * Summary's "Donor contact" row — for an Organisation record this is the referent contact.
 */
export function buildContactRoute(contactId) {
    return contactId ? { name: "ContactDetail", params: { id: contactId } } : null;
}
